<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        <kendo-datetimepicker
            class="bg-input text-input-foreground"
            [ngClass]="generateInputStyle()"
            [id]="id"
            [title]="title | translate"
            [placeholder]="placeholder"
            [format]="format"
            [required]="isRequired"
            [max]="maxDate"
            [min]="minDate"
            [disabled]="isDisabled"
            [disabledDates]="disabledDates"
            [ngModel]="dateValue()"
            (valueChange)="onValueChange($event)"
            (inputFocus)="onFocusIn()"
            (inputBlur)="onFocusOut()">
            <kendo-datetimepicker-messages
                [today]="'Today' | translate"
                [dateTab]="'Date' | translate"
                [timeTab]="'Time' | translate"
                [now]="'Now' | translate"
                [accept]="'Accept' | translate"
                [cancel]="'Cancel' | translate" />
        </kendo-datetimepicker>
    } @else {
        <div class="pb-1 pt-1.5" kendoTooltip position="top" [title]="dateValue() | date: format">
            {{ dateValue() | date: format }}
        </div>
    }
</app-input-label>
